import { checkAllRequiredElements } from './elementsChecking';
import { saveAs } from 'file-saver';
import generateJSON from './jsonGenerating';
import { parse } from 'js2xmlparser';
import { GetTemplateNames } from './liquidXmlParser/liquidXmlParser';
import { parseCreatorSitesContent, parseCreatorSitesContentOnTemplateSelection } from './creatorSitesParser';
import { getListNames } from './listBodyUtils';
import releaseSettings from '../config/releaseSettings';
import { getLiquidSettings } from './liquidXmlParser/liquidXmlSettings';
import { getGlobalName, getGlobalTemplateName } from './liquidXmlParser/liquidXmlGlobalName';
import { defaultThemeName, defaultMaxPrevSteps, defaultTemplateNameAbbreviation } from '../config/defaults';
import { changeTheme } from './themeChanger';
import { getImportedTemplateSettingsObject } from '../assets/creator/template';
import { linksGenerator } from './welcomeModalsUtils';

function handleGenerate() {
    if (canGenerate.call(this)) {
        generate.call(this);
        this.setState({ isGenerateTemplateModalOpen: true });
    } else {
        this.setState({ isCheckRequiredEnabled: true });
        this.pushNotification("error", "Ntf_FillRequiredElements");
    }
}
/**
 * Function that is automatically run when the xml template file content is loaded
 * @param {string} xmlString 
 */
function handleImport(xmlString, z) {
    let templateNames = null;
    const newXmlString = xmlString.replace(/&quot;/g,'"');
  
    try {
        if (getGlobalTemplateName(newXmlString).includes(defaultTemplateNameAbbreviation)) {
            templateNames = GetTemplateNames(newXmlString);
            const isGetSettings = getLiquidSettings.call(this, newXmlString);
            getImportedTemplateSettingsObject(); // Get settings from XML file 
            this.optionsRef.current.componentSettingsUpdateAfterImport(); //Update Options to get imported settings
            if (isGetSettings) {
                this.setTemplateName(getGlobalName(newXmlString));
            }
            parseCreatorSitesContent.call(this, newXmlString, templateNames);
            if (!isGetSettings) {
                this.pushNotification("error", "Ntf_FailedToLoadTemplate");
            }
            else {
                this.pushNotification("success", "Ntf_TemplateLoadedSuccessfully");
                this.setState({ prevSteps: this.initPrevStepsState(defaultMaxPrevSteps)});
                this.setState({ nextSteps: [{ typeOfChange: 0, value: null }]});
                this.setState({ disablePrev: true});
                this.setState({ disableForward: true});
                z()
            }
        } else {
            throw new Error('Wrong temmplate');
        }
    } catch (e) {
        //TODO display this message somewhere
        console.log(e)
        this.pushNotification("error", "Ntf_FailedToLoadTemplate");
        return;
    }
}

function handleImportPredefinedTemplate() {
    handleClearLocalStorage.call(this);
    try {
        changeTheme.call(this, this.state.currentThemeName);
        this.setTemplateName(this.state.defaultTemplateName);
        parseCreatorSitesContentOnTemplateSelection.call(this, this.state.selectedTemplate);
        this.pushNotification("success", "Ntf_TemplateLoadedSuccessfully");
    } catch (e) {
        console.log(e)
        this.pushNotification("error", "Ntf_FailedToLoadTemplate");
        return;
    }
}

function canGenerate() {
    checkAllRequiredElements.call(this);
    return this.missingTypes.length < 1;
}

function isLocalStorageEmpty() {
    const savedElementsLists = getListNames();

    const isAnyElementSaved = savedElementsLists.some(list => {
        return (!!localStorage.getItem(this.prefix + list));
    });
    return !isAnyElementSaved;
}

//confusing function name, because previous version with settings was causing black screen bug after generated and refreshed page (complete template) 
export function retrieveSettingsFromLocalStorage() {
    const currentThemeName = JSON.parse(localStorage.getItem(this.prefix + "currentThemeName"));

    if (currentThemeName) {
        changeTheme.call(this, currentThemeName);
    } else {
        changeTheme.call(this, defaultThemeName);
    }
    
    this.pushNotification("success", "Ntf_RetrieveSettings");
}

function handleRestoreFromLocalStorage() {
    const lists = getListNames();
    const localStorageLists = {};

    //get all page content from local storage
    lists.forEach(listName => {
        const savedList = localStorage.getItem(this.prefix + [listName]);
        if (!savedList) {
            localStorageLists[listName] = [];
        } else {
            localStorageLists[listName] = JSON.parse(savedList);
        }
    });

    retrieveSettingsFromLocalStorage.call(this);
    const templateName = localStorage.getItem(this.prefix + "templateName");
    if (templateName) {
        this.setTemplateName(templateName);
    }
    //push retrieved items from state
    this.setState({
        ...localStorageLists,
        isWelcomeModalOpen: false
    });
    //try get counter for unique banner ids from storage
    if (localStorage.getItem('counterB2B')) {
        this.counter = JSON.parse(localStorage.getItem('counterB2B'));
    }
}

function handleClearLocalStorage() {
    changeTheme.call(this, defaultThemeName);
    const currentLang = localStorage.getItem('langB2B');
    localStorage.clear();
    if(currentLang !== null && currentLang !== 'null') {
        localStorage.setItem('langB2B', currentLang);
    } else {
        localStorage.setItem('langB2B', 'pl');
    }
    this.setState({
        isTemplateMenuModalOpen: false,
        isInformativeModalVisible: true,
        prevSteps: this.initPrevStepsState(defaultMaxPrevSteps),
        disablePrev: true,
    });
}

function fillZeros(num, tenPow) {
    let zeros = tenPow;
    let cmp = 10;
    for (let i = 0; i < tenPow; i++) {
        if (num < cmp) {
            return '0'.repeat(zeros) + num;
        }
        cmp *= 10;
        zeros--;
    }
    return num;
}

function getPathDateString() {
    const date = new Date();
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    month = fillZeros(month, 1);
    day = fillZeros(day, 1);
    hours = fillZeros(hours, 1);
    minutes = fillZeros(minutes, 1);
    return `${year}${month}${day}_${hours}${minutes}`
}

function ReplaceInvalidFileNameChars(fileName) {
    return fileName.replace(/[^ęĘóÓąĄśŚłŁżŻźŹćĆńŃA-Za-z0-9_-]/g, '-');
}

function generateTemplateCopyForFB(js) {
    js.Templates.Template.forEach(template => {
        const templateCopy = JSON.parse(JSON.stringify(template));
        templateCopy["@"].Mode = 2;
        js.Templates.Template.push(templateCopy);
    });
}

async function generate() {
    const js = generateJSON.call(this);
	generateTemplateCopyForFB(js);
    const templateName = ReplaceInvalidFileNameChars(this.state.templateName);
    const filename = `${templateName}_${getPathDateString()}.xml`;
    
    
    const xmlstring = parse("Liquid", js);
    if (releaseSettings.saveXml) {
        if (this.props.isInIframe) {
            const link = await linksGenerator();
            window.parent.postMessage(xmlstring, link.b2b);
        } else {
            const xml = new Blob([xmlstring], { type: "application/xml;charset=utf-8" });
            saveAs(xml, filename);
        }
    }
    else {
        console.warn("Xml export is disabled in config/releaseSettings, please enable it to get the xml")
    }
}


export { handleClearLocalStorage, handleRestoreFromLocalStorage, isLocalStorageEmpty, handleGenerate, handleImport, handleImportPredefinedTemplate };

